import React, { useRef } from 'react';
import { ChannelEventType, useChatStore } from 'src/common/chat/store';
import { useChatUserActions } from 'src/common/chat/user-actions.hook';
import { useDashboardInboxStore } from './store';

export const useDashboardInboxUserActions = () => {
  let readChannelIdsRef = useRef<Array<ChannelEventType['cid']>>([]);
  const { listenChannelEvent, unlistenChannelEvent } = useChatStore();
  const { markChannelAsRead, setTotalUnreadMessageCount } = useDashboardInboxStore();
  const { sendChatMessage } = useChatUserActions();

  const onMessageRead = useRef((event: ChannelEventType) => {
    if (!readChannelIdsRef.current.includes(event.cid)) {
      markChannelAsRead(event.cid);
    }
    readChannelIdsRef.current.push(event.cid);
  });

  const listenMessageReadEvent = () => listenChannelEvent('message.read', onMessageRead.current);
  const unlistenMessageReadEvent = () => unlistenChannelEvent('message.read', onMessageRead.current);

  return { setTotalUnreadMessageCount, sendChatMessage, listenMessageReadEvent, unlistenMessageReadEvent };
};
